import { memo } from "react";
import Link from "next/link";

import Cart from "@/components/Cart.component";

import styles from "@/styles/layout.module.scss";

const Header = () => {

    return (
        <header className={styles["header"]}>
            <div className={styles["header-bar"]}>
                <div className={styles["header-email"]}>
                    {/* <i className="fa fa-envelope" aria-hidden="true"></i> */}
                    <Link href={`mailto:info@doctorcarparts.com`} >
                        info@doctorcarparts.com
                    </Link>
                </div>

                <div className={styles["header-title"]}>
                    <Link href="/" >
                        {process.env.NEXT_PUBLIC_HEADER_TITLE || "Doctor Car Parts"}
                    </Link>
                </div>

                <div className={styles["header-phone"]}>
                    {/* <i className="fa fa-phone-square" aria-hidden="true"></i> */}
                    <Link href={`tel:01157270786`} >
                        0115 727 0786
                    </Link>
                </div>

                <Cart />
            </div>
        </header>
    );
};

export default memo(Header);
